'use strict';


module.exports = {
    viewports: require('./viewports'),
    positions: require('./positions')
};
